/**
 * Minimal metadata handler kept for API compatibility with the editor shell.
 */
export default class DashboardMetadataHandler {
    /**
     * Create a dashboard data provider instance.
     *
     * @param {*} metadata
     */
    constructor(metadata) {
        this.supportedMetadata = null;
        this.setMetadata(metadata);
        this.vue = window.AppKit.getApp();
    }

    /**
     * Return the current metadata payload.
     */
    getMetadata() {
        return this.metadata;
    }

    /**
     * Replace the current metadata payload.
     */
    setMetadata(metadata) {
        this.metadata = metadata;
    }
}
